import React from "react";

import { Box, Button, CircularProgress, Grid } from "@mui/material";

import { colors } from "@/theme/overrides/colors";

import FinishButton from "../../../../components/FinishButton";

interface Props {
  nextLabel?: string;
  isSubmitting?: boolean;
  onNext?: () => void;
  onSkip?: () => void;
  onBack?: () => void;
  isPrivacyPolicyChecked?: boolean;
  submitOnNext?: boolean;
}
const Footer: React.FC<Props> = ({
  nextLabel = "Next",
  isSubmitting = false,
  onNext,
  onSkip,
  onBack,
  isPrivacyPolicyChecked,
  submitOnNext = false,
}) => {
  const privacyPolicy = isPrivacyPolicyChecked ?? true;

  return (
    <Grid container alignItems="center">
      <Grid item xs={1}>
        {Boolean(onBack) && (
          <Box marginLeft="-16px" color={colors.dark}>
            <Button variant="text" color="inherit" onClick={onBack}>
              Back
            </Button>
          </Box>
        )}
      </Grid>
      <Grid item container xs justifyContent="center">
        {submitOnNext ? (
          <FinishButton type="submit" disabled={isSubmitting || !privacyPolicy}>
            {isSubmitting ? <CircularProgress /> : nextLabel}
          </FinishButton>
        ) : (
          <FinishButton onClick={onNext} disabled={!privacyPolicy}>
            {nextLabel}
          </FinishButton>
        )}
      </Grid>
      <Grid item container xs={1} justifyContent="flex-end">
        {Boolean(onSkip) && (
          <Box marginRight="-8px" color={colors.grey}>
            <Button variant="text" color="inherit" onClick={onSkip}>
              Skip &gt;&gt;
            </Button>
          </Box>
        )}
      </Grid>
    </Grid>
  );
};

export default Footer;
